/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import urlJoin from 'proper-url-join';

import { PaginatedResult, StoreQueryParams } from '@ibm-watson/shared/ts';
import { ActivityLog } from '../../../../ts/activity-log';
import { endpoints } from '../../util/config';

export interface PaginatedActivityLogs extends PaginatedResult {
  event_logs: ActivityLog[];
  pagination: PaginatedResult;
}

const endpoint = (assistantId: string, environmentId?: string) =>
  urlJoin(
    `${endpoints.store}/v2/assistants/${assistantId}/event_logs`,
    environmentId
  );

const auditParams: StoreQueryParams = {
  include_audit: true,
  include_count: true,
  verbose: true,
  page_limit: 500
};

export const listActivityLogs = async (
  assistantId: string,
  queryParams: any
): Promise<PaginatedActivityLogs> => {
  const response = await axios.get<PaginatedActivityLogs>(
    urlJoin(endpoint(assistantId)),
    {
      params: {
        ...queryParams,
        ...auditParams
      }
    }
  );

  return response.data;
};

export const listActivityLogsByUrl = async (
  url: string
): Promise<PaginatedActivityLogs> => {
  const response = await axios.get(urlJoin(endpoints.store, url));
  return response.data;
};
